import React from "react";

import FidelitySynapsy from "../FidelityFranchise/FidelitySynapsy";
import { FidelityFormApi } from "../useFidelityForm";

type Props = {
    form: FidelityFormApi;
    setIsEdited: (v: boolean) => void;
};

export default function SynapsySection({ form, setIsEdited }: Props) {
    const { values, errors, setValue, setError } = form;

    return (
        <FidelitySynapsy
            password={values.password}
            setPassword={(v: string) => setValue("password", v)}
            login={values.login}
            setLogin={(v: string) => setValue("login", v)}
            inputLogin={errors.login}
            setInputLogin={(v: boolean) => setError("login", v)}
            inputPassword={errors.password}
            setInputPassword={(v: boolean) => setError("password", v)}
            setIsEdited={setIsEdited}
        />
    );
}
